(function() {
  "use strict";

    angular.module("eSign")
    .directive('fileModel', ['$parse', '$timeout', function ($parse, $timeout) {
      return {
          restrict: 'A',
          link: function(scope, element, attrs) {

              var model = $parse(attrs.fileModel);
              var modelSetter = model.assign;

              element.bind('change', function(changeEvent){
                  $timeout(function() {
                    modelSetter(scope, element[0].files);
                  });
              });

          }
      };
    }]);
}());
